//@ts-check
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/providers.jsx';
import { router } from '@/app/router.jsx';

/**
 * Root application component.
 * @returns {import('react').ReactElement}
 */
export default function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
